import React, { Fragment, useContext,useEffect } from 'react';
import BeneficiaryContext from "../BeneficiaryContext";
import {
  educationSavingsWarningNotification,
  formatAndHideTaxId,
  formatStringIfEducationSavings,
  renderDesignation,
  renderType,
  typeIsIndividual,
  validateBeneficiariesData
} from 'services/BeneficiaryV2';
import { educationSavingsWarning, getDisplayBirthdate } from 'services/Beneficiary';
import BeaconNotification from 'components/shared/BeaconNotification/BeaconNotification';

const BeneficiaryDetails = () => {
  const { updatedBeneficiary, selectedGroup, isEdited, isAdded, beneficiaries, isEsa, recentBeneficiary, setBeneficiaryDataIsComplete } = useContext(BeneficiaryContext);
  const { primary, secondary } = beneficiaries;
  if (!updatedBeneficiary) {
    return null;
  }
  const {
    designationId,
    typeId,
    firstName,
    middleName,
    lastName,
    name,
    relationshipName,
    nameSuffix,
    birthDate,
    taxId
  } = recentBeneficiary;
  const isIndividual = typeIsIndividual(typeId);
  const mergedBenes = [...primary, ...secondary];

  useEffect(() => {
    setBeneficiaryDataIsComplete(validateBeneficiariesData(mergedBenes));
  }, [mergedBenes]);
  const showEducationSavingsWarning = educationSavingsWarning(
    mergedBenes,
    true,
    isEsa
  );
  return (
    <div className="b-grid b-padding-block-end--macro--jumbo">
      <div className="b-grid-item--12-col">
        <div id="modal-header" className="b-typography-serif--headline--200 b-font-weight-bold">
          {formatStringIfEducationSavings('Your Beneficiaries', isEsa)}
        </div>
        <div className="b-typography-sans-serif--body--200">
          <span className="b-font-weight-light">Assigned to </span>
          <span className="b-font-weight-bold blocked_data">{selectedGroup}</span>
        </div>
        <div className="b-typography-serif--body--200">
          Here&apos;s the most recent {renderDesignation(designationId, isEsa)} beneficiary you&apos;ve named.
        </div>
      </div>
      {(isAdded || isEdited) &&
        <div className="b-grid-item--12-col">
          <BeaconNotification title={formatStringIfEducationSavings(isEdited ? 'Beneficiary edited' : 'Beneficiary named', isEsa)}
            variant="success"
            label="ViewBeneficiary"
            dismissable={true}
            type="inline" />
        </div>}
      <div className="b-grid-item--12-col">
        {showEducationSavingsWarning && educationSavingsWarningNotification}
      </div>
      <div className="b-grid-item--12-col">
        {!isEsa && (
          <>
            <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
              Beneficiary type
            </div>
            <div className="b-typography-sans-serif-body-100 b-font-weight-light">
              {renderType(typeId)}
            </div>
          </>
        )}
      </div>
      <div className="b-grid-item--12-col">
        {(name && !firstName) && (
          <Fragment>
            <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
              Name
            </div>
            <div className="b-typography-sans-serif-body-100 b-font-weight-light blocked_data">
              {name}
            </div>
          </Fragment>
        )}
        {firstName && (
          <Fragment>
            <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
              First name
            </div>
            <div className="b-typography-sans-serif-body-100 b-font-weight-light blocked_data">
              {firstName}
            </div>
          </Fragment>
        )}
      </div>
      {middleName && (
        <div className="b-grid-item--12-col">
          <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
            Middle name
          </div>
          <div className="b-typography-sans-serif-body-100 b-font-weight-light blocked_data">
            {middleName}
          </div>
        </div>
      )}
      {lastName && (
        <div className="b-grid-item--12-col">
          <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
            Last name
          </div>
          <div className="b-typography-sans-serif-body-100 b-font-weight-light blocked_data">
            {lastName}
          </div>
        </div>
      )}
      {nameSuffix && (
        <div className="b-grid-item--12-col">
          <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
            Suffix (optional)
          </div>
          <div className="b-typography-sans-serif-body-100 b-font-weight-light blocked_data">
            {nameSuffix}
          </div>
        </div>
      )}
      {(relationshipName && isIndividual) && (
        <div className="b-grid-item--12-col">
          <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
            Relationship
          </div>
          <div className="b-typography-sans-serif-body-100 b-font-weight-light blocked_data">
            {relationshipName}
          </div>
        </div>
      )}
      {birthDate && (
        <div className="b-grid-item--12-col">
          <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
            Date of Birth (optional)
          </div>
          <div className="b-typography-sans-serif-body-100 b-font-weight-light blocked_data">
            {getDisplayBirthdate(birthDate)}
          </div>
        </div>
      )}
      {taxId && (
        <div className="b-grid-item--12-col">
          <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
            Social Security/TIN (optional)
          </div>
          <div className="b-typography-sans-serif-body-100 b-font-weight-light blocked_data">
            {formatAndHideTaxId(taxId, typeId)}
          </div>
        </div>
      )}
    </div>
  );
};
export default BeneficiaryDetails;
